import PoweredBy from "./PoweredBy";

export default function MultiStepLayout({
  children,
  foregroundColor,
  formBackgroundColor,
  className,
  isMobile,
  showPoweredBy,
}) {
  return (
    <div
      className={`w-full text-white relative ${className || ""} ${showPoweredBy ? "flex flex-col justify-center" : ""}`}
      style={{
        backgroundColor: formBackgroundColor,
        color: foregroundColor,
        minHeight: isMobile ? "760px" : "460px",
      }}
    >
      <div style={{ backgroundColor: formBackgroundColor }} className="h-full">
        <div className="px-4 h-full">{children}</div>
      </div>

      {showPoweredBy &&
        <div
          className="absolute bottom-6 w-full text-center"
          style={{ backgroundColor: formBackgroundColor }}
        >
          <PoweredBy backgroundColor={formBackgroundColor} />
        </div>
      }
    </div>
  );
}
